<div class='errorPage'>
  <h1 class='error-text'>{{errorHeader}}</h1>
  <div class='error-img'>
    <img src="../../assets/images/AccessFailEmoji.svg" alt="error page" />
  </div>
  <p class='error-message'>{{errorText}}</p>
  <p class='error-message'>{{errorSubText}}</p>
</div>